import http from "../services/httpServices";
import React, { useContext, useEffect, useState, useRef } from "react";
import Offcanvas from 'react-bootstrap/Offcanvas';
import { toast } from "react-toastify";
import utils from "../services/utilsServices";
import cardService from "../services/cardServices";
import { MainContext } from "../store/mainContext";
export default function AddDevice({ show, handleClose }) {
    const { defaultDevice, setDefaultDevice } = useContext(MainContext);
    useEffect(() => {
    }, []);

    const [form, setForm] = useState({ deviceName: "", deviceNumber: "" })
    const formRef = useRef(null);

    const [isPosting, setIsPosting] = useState(false)
    const doPost = async (e) => {
        e.preventDefault();
        e.stopPropagation()
        const forms = formRef.current;
        if (forms.checkValidity() === false) {
            toast.error(utils.checkInput, { theme: "colored" });
            forms.classList.add('was-validated')
            return;
        }
        //setIsPosting(true);
        const temp = { ...form };
        temp.deviceNumber = utils.checkNumber(form.deviceNumber);
        cardService.addSaveCard([{
            deviceName: temp.deviceName,
            deviceNumber: temp.deviceNumber,
            id: (new Date()).getTime(),
        }]);
        cardService.saveChoiceCard(temp);
        setDefaultDevice(temp)
        handleClose(e, temp)
    }

    return (
        <>
            <Offcanvas
                show={show}
                onHide={handleClose}
                placement="bottom"
                className="customBottomCanvas "  >
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title className="w-100 d-flex justify-content-center">  افزودن ردیاب</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <form ref={formRef} className=" needs-validation" >
                        <div className="form-floating mb-3">
                            <input
                                type="text"
                                className="form-control"
                                name="deviceName"
                                value={form.deviceName}
                                onChange={e => http.handleChange(e, form, setForm)}
                                placeholder=" "
                                required />
                            <label htmlFor="floatingInput">نام (مثلا پارس)</label>
                        </div>
                        <div className="form-floating mb-3">
                            <input
                                type="number"
                                className="form-control"
                                name="deviceNumber"
                                value={form.deviceNumber}
                                onChange={e => http.handleChange(e, form, setForm)}
                                placeholder=" "
                                required />
                            <label htmlFor="floatingInput">سیم کارت ردیاب (09123456789)</label>
                        </div>
                        <div className='row mt-3 '>
                            <div className='col'>
                                <button className='btn btn-warning w-100'
                                    disabled={isPosting}
                                    onClick={doPost}>تایید
                                    {isPosting &&
                                        <div className="spinner-border spinner-border-sm" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                    }
                                </button>
                            </div>
                        </div>
                    </form>
                </Offcanvas.Body>
            </Offcanvas>
        </>

    );

}
